import { getReduxSelector } from '@gymaholic/packages'
import { PLANS_PATH } from 'modules/plan/redux/constants/index.js'

const getTagPlansSelect = state => getReduxSelector(PLANS_PATH.TAG)(state)

export default getTagPlansSelect
